import React, { useContext, useState, useEffect, Fragment } from 'react'
import { P, H2, H5, Error, Span } from '../../components/basic/text'
import { Button, Input, Flex, Block, Grid } from '../../components/basic'
import { PostBuilderData, PostSaveAndEmailDesign } from '../../api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GAContext } from '../../context/googleAnalytics'
import { faChevronLeft, faChevronRight, faBars, faTimes, faShoppingCart, faArrowRight, faArrowLeft, faSave } from '@fortawesome/fontawesome-free-solid'
import { TopStepNavigation } from './topStepNavigation'
import {Blue, Blue_900, Blue_400, White, Gray_600} from '../../constants/colors'
import { GaSavedDesignComplete, GaSaveDesignInitiated, GaDesignerSubStepComplete, GaDesignerStepComplete, GaDesignerComplete, GaAddToCart } from '../../data/googleAnalytics'
import { DISPLAY_TYPES, NO_THANKS_OPTION } from './constants'

export const CreateOutputData = (state, gaState, gaDispatch, productData, fromSaveDesign, saveDesignObj, data) => {
    let newData = []
    let locationsUsed = {}
    //API wanted output in reverse order
    const builderOutput = Object.values(state.choices).reverse()
    for(let i = 0; i < builderOutput.length; i++) {
        let configurations = []
        let gaGuid = {}
        let gaRefGuid = {}
        if(builderOutput[i].fields && (Object.keys(builderOutput[i].fields).length > 0)) {
            let outputFieldValues = builderOutput[i].fields
            let outputFieldKeys = Object.keys(builderOutput[i].fields)
            for(let j = 0; j < outputFieldKeys.length; j++) {
                let configData = {}
                let optionData = {}
                for(let k = 0; k < builderOutput[i].product.configurations.length; k++) {
                    if(builderOutput[i].product.configurations[k].featureOsr === outputFieldKeys[j]) {
                        configData = builderOutput[i].product.configurations[k]
                    }
                }
                for(let l = 0; l < outputFieldValues[outputFieldKeys[j]]?.options?.length; l++) {
                    if(outputFieldValues[outputFieldKeys[j]].options[l].optionOsr === outputFieldValues[outputFieldKeys[j]].chosenOsr) {
                        optionData = outputFieldValues[outputFieldKeys[j]].options[l]
                    }
                }
                const featureConf = {
                    hidden: configData.hidden,
                    selected: configData.selected,
                    productAsConfiguration: configData.productAsConfiguration,
                    customDesign: configData.customDesign,
                    allowedInFinalConfig: configData.allowedInFinalConfig,
                    licensingRequired: configData.licensingRequired,
                    finalConfiguration: configData.finalConfiguration,
                    specialInstructRequired: configData.specialInstructRequired,
                    configuredInCart: configData.configuredInCart,
                    featureOsr: outputFieldKeys[j],
                    featureId: outputFieldValues[outputFieldKeys[j]].featureId,
                    optionOsr: outputFieldValues[outputFieldKeys[j]].chosenOsr === NO_THANKS_OPTION.displayName ? null : outputFieldValues[outputFieldKeys[j]].chosenOsr,
                    optionId: optionData.optionId ? optionData.optionId : outputFieldValues[outputFieldKeys[j]].optionId,
                    displayedInCart: configData.displayedInCart,
                    valueProvider: configData.valueProvider,
                    optionValue: outputFieldValues[outputFieldKeys[j]].chosenValue === NO_THANKS_OPTION.displayName ? null : outputFieldValues[outputFieldKeys[j]].chosenValue
                }
                // drop optionValue for non inscript text fields [JCOM-49721]
                const productFeature = builderOutput[i].product.features.find(feature => feature.featureOsr === outputFieldValues[outputFieldKeys[j]].featureOsr)
                if (productFeature?.displayType !== DISPLAY_TYPES.INSCRIPT) {
                    delete featureConf.optionValue
                }
                configurations.push(featureConf)
            }
        }
        if(builderOutput[i].product.configurations && builderOutput[i].product.configurations.length > 0) {
            for(let k = 0; k < builderOutput[i].product.configurations.length; k++) {
                if((builderOutput[i].product.configurations[k].featureOsr === "GA-UPSELL-PARENT-GUID") && builderOutput[i].required) {
                    gaGuid = builderOutput[i].product.configurations[k]
                }
                if((builderOutput[i].product.configurations[k].featureOsr === "GA-UPSELL-PARENT-REF-GUID") && !builderOutput[i].required) {
                    gaRefGuid = builderOutput[i].product.configurations[k]
                }
            }
        }
        if(gaGuid && (Object.values(gaGuid).length > 0)) {
            configurations.push(gaGuid)
        }
        if(gaRefGuid && (Object.values(gaRefGuid).length > 0)) {
            configurations.push(gaRefGuid)
        }
        //If not thanks is selected, do not put any data in the checkout output
        let date =  new Date().getFullYear()
        if(builderOutput[i]?.product?.displayName && builderOutput[i].product.displayName !== "No Thanks") {
            newData.push({
                displayName: builderOutput[i].product.displayName,
                productName: builderOutput[i].product.productName,
                productOsr: builderOutput[i].product.productOsr,
                productType: builderOutput[i].product.productType,
                publishedProductId: builderOutput[i].product.publishedProductId,
                publishedCatalogId: fromSaveDesign ? builderOutput[i].product.publishedCatalogId : undefined,
                orderItemId: builderOutput[i].product.orderItemId ? builderOutput[i].product.orderItemId : undefined,
                sourceCatalogType: builderOutput[i].product.sourceCatalogType,
                schoolYear: productData ? productData.schoolYear : date,
                required: builderOutput[i].required,
                basePrice: builderOutput[i].basePrice,
                featurePrice: builderOutput[i].featurePrice,
                configurations: configurations
            })
        }
        if(data?.steps?.length > 0 && fromSaveDesign){
            data.steps.map((step)=> {
                if(step.substeps?.length > 0){
                    step.substeps.map((substep)=> {
                        if(substep.title === builderOutput[i].title){
                            if(builderOutput[i]?.product?.displayName && builderOutput[i].product.displayName !== "No Thanks"){
                                if(substep.locations?.length > 0){
                                    locationsUsed[substep.locations[0]] = builderOutput[i].product.publishedProductId
                                }else if(substep.products?.length > 0){
                                    locationsUsed[substep.products[0]] = builderOutput[i].product.publishedProductId
                                }
                            }
                            if(builderOutput[i]?.product?.displayName && builderOutput[i].product.displayName === "No Thanks"){
                                if(substep.locations?.length > 0){
                                    locationsUsed[substep.locations[0]] = "N"
                                }else if(substep.products?.length > 0){
                                    locationsUsed[substep.products[0]] = "N"
                                }
                            }
                        }
                        return true
                    })
                }
                return true
            })
        }
    }
    if((!gaState.checkout) && (!fromSaveDesign)) {
        if (window.jostensGaTracking) {    // triggered only for GASY25 or newer code
            GaDesignerStepComplete(state, data)
            GaDesignerComplete(state, data)
        }
        GaAddToCart(newData, state)
        gaDispatch({type: 'SET_CHECKOUT', payload: true})
    }
    if(fromSaveDesign){
        let postData = {};
        postData = { ...saveDesignObj }
        postData.actualLocationProducts = locationsUsed
        postData.products = newData
        return postData
    }else{
        return newData
    }
}

export const BottomStepNavigation = props => {
    const [gaState, gaDispatch] = useContext(GAContext)
    const { state, dispatch, navigationData, data, productData } = props
    const [previous, setPrevious] = useState(null)
    const [next, setNext] = useState(null)
    const [popup, setPopup] = useState(false)
    let saveDesignObj = {"sendOffers":true}
    const mobile = state.resize < 1025
    
    const NavigatePrevious = () => {
        mobile && window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
        dispatch({type: 'SET_STEP', payload: previous.step})
        dispatch({type: 'SET_SUBSTEP', payload: previous.title})
        setPopup(false)
    }

    const NavigateNext = () => {
        mobile && window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
        if(!gaState.exitSubstep.includes(state.substep)) {
            const currentExitSubsteps = gaState.exitSubstep
            currentExitSubsteps.push(state.substep)
            GaDesignerSubStepComplete(state, data)
            gaDispatch({type: 'SET_EXIT_SUBSTEP', payload: currentExitSubsteps})
        }
        if(next.step !== state.step) {
            if(!gaState.exitStep.includes(state.step)) {
                const currentExitSteps = gaState.exitStep
                currentExitSteps.push(state.step)
                GaDesignerStepComplete(state, data)
                gaDispatch({type: 'SET_EXIT_STEP', payload: currentExitSteps})
            }
        }
        if(next.step === "Review") {
            if(!gaState.enterReview) {
                if (!window.jostensGaTracking) {    // triggered only for legacy GA code
                    GaDesignerComplete(state, data)
                }
                gaDispatch({type: 'SET_ENTER_REVIEW', payload: true})
            }
        }
        dispatch({type: 'SET_STEP', payload: next.step})
        dispatch({type: 'SET_SUBSTEP', payload: next.title})
        setPopup(false)
    }

    const Submit = () => {
        sessionStorage.setItem("addToCartCheck", true)
        PostBuilderData(JSON.stringify(CreateOutputData(state, gaState, gaDispatch, productData), undefined, 2), dispatch, state.builder)
    }

    const SaveAndEmailDesign = () => {

        if(saveDesignObj?.email && saveDesignObj?.firstName && saveDesignObj?.lastName && (document.getElementById("errorEmail").innerHTML === "")){
            PostSaveAndEmailDesign(JSON.stringify(CreateOutputData(state, gaState, gaDispatch, productData, true, saveDesignObj, data)), dispatch, state.builder)
            GaSavedDesignComplete(state, data)
        }
    }

    const handleChange = (key, value) => {
        if(key === "email"){
            const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(regex.test(String(value).toLowerCase())){
                document.getElementById("errorEmail").innerHTML = "";
            }else{
                document.getElementById("errorEmail").innerHTML = "Enter valid email";
            }
        }
        saveDesignObj[key] = value.trim();
    }
    const SaveDesignPopUp = () => {
        GaSaveDesignInitiated(state, data)
        dispatch({type: "SET_POPUP", payload: {
            title: <H2 align="center" margin="0 0 10px 0">Save Your Design</H2>,
            subTitle: <H5 align="center" margin="0 0 60px 0" color={Gray_600} hover={Gray_600}>Enter your details below to save your design</H5>,
            info: <Fragment>
                <Fragment>
                    <Block margin="20px 0 0 0"
                        key={"Fields-Input-Email"}>
                        <Input 
                            title="Email Address"
                            legend="Email Address"
                            type="text"
                            required={true}
                            placeholder="Enter your email address"
                            onChange={event => handleChange("email", event.target.value)}
                            regex={/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                            
                        />
                        <Error id="errorEmail"></Error>
                    </Block>
                    <Block margin="20px 0 0 0"
                        key={"Fields-Input-FirstName"}>
                        <Input 
                            title="First Name"
                            legend="First Name"
                            type="text"
                            required={true}
                            maxLength={20}
                            placeholder="Enter your first name"
                            onChange={event => handleChange("firstName", event.target.value)}
                            
                        />
                    </Block>
                    <Block margin="20px 0 0 0"
                        key={"Fields-Input-LastName"}>
                        <Input 
                            title="Last Name"
                            legend="Last Name"
                            type="text"
                            required={true}
                            placeholder="Enter your last name"
                            maxLength={20}
                            onChange={e => handleChange("lastName", e.target.value)}
                        />
                    </Block>
                    <Flex margin="20px 0 0 0" justify="start">
                        <Input
                            type="checkbox"
                            legend="Special Offers"
                            id="sendOffersCheckbox"
                            defaultChecked={true}
                            onChange={e => e.target.checked ?  saveDesignObj["sendOffers"]=true : saveDesignObj["sendOffers"]=false}
                        />
                        <Span
                            for="sendOffersCheckbox"
                            margin="0 0 0 15px"
                            color={Gray_600}
                        >Yes, send me special offers from Jostens</Span>
                    </Flex>
                    <P margin="20px 0 0 0" justify="start" color={Gray_600}>* Required field</P>
                </Fragment>
                <Grid margin="30px 0 0 0">
                    <Block></Block>
                    <Block>
                        <Button onClick={() => SaveAndEmailDesign()} fontSize={(mobile && mobile < 450) ? "10px" : "12px"} width="calc(100% - 30px)"
                            hoverBackground={Blue} color={White} background={Blue} border="2px solid" borderColor={!mobile ? Blue : Blue_400} padding={mobile && "15px 10px"}>
                            <Fragment>{"SAVE & EMAIL DESIGN"} &nbsp; <FontAwesomeIcon icon={faArrowRight} /></Fragment>
                        </Button>
                    </Block>
                </Grid>
            </Fragment>
        }})
    }

    useEffect(() => {
        const CalculateNavigation = () => {
        let activeSubstep = navigationData.find(item=>item.title===state.substep && item.step===state.step);
        const activeIndex = navigationData.findIndex(step => step.key === activeSubstep?.key);
            if (activeIndex < 1) {
                setPrevious(null);
            }
            if (activeIndex > 0) {
                setPrevious(navigationData[activeIndex - 1]);
            }
            if (state.step !== "Review" && activeIndex < navigationData.length - 1) {
                setNext(navigationData[activeIndex + 1]);
            } else if (state.step !== "Review" && activeIndex === navigationData.length - 1) {
                setNext({
                    title: "Review",
                    step: "Review"
                });
            }
            if (state.step === "Review") {
                setPrevious(navigationData[navigationData.length - 1]);
                setNext(null);
            }
        }
        CalculateNavigation()
    }, [state.substep, navigationData, state.step])

    return (
        <Flex bottom={mobile && "0px"}
            left={mobile && "0px"}
            right={mobile && "0px"}
            position={mobile && "fixed"}
            justify="space-between"
            padding={!mobile && "15px"}
            z={mobile ? 9 : '0'}
            background={mobile && Blue_900}>
            {popup && mobile
                && <Block height="calc(100vh - 50px)" background="#3F506A" position="absolute" bottom="50px">
                    <Block position="absolute" bottom="0">
                        <TopStepNavigation callback={() => setPopup(false)} state={state} dispatch={dispatch} data={data} />
                    </Block>
                </Block>
            }
            <Block width="auto" margin="0 10px 0 0">
                {previous && <Button onClick={() => NavigatePrevious()}
                    hoverBackground={Blue} color={!mobile ? Blue : White} background={mobile ? Blue_400 : White} border="2px solid" borderColor={!mobile ? Blue : Blue_400} padding={mobile && "15px 20px"}>
                        {mobile
                            ? <FontAwesomeIcon icon={faChevronLeft} />
                            : <Fragment><FontAwesomeIcon icon={faArrowLeft} /> PREVIOUS: {previous.title.toUpperCase()}</Fragment>
                        }
                    </Button>
                }
            </Block>
            <Block width="auto" margin="0 10px 0 0">
                {<Button onClick={() => SaveDesignPopUp()}
                    hoverBackground={Blue} color={!mobile ? Blue : White} background={mobile ? Blue_400 : White} border="2px solid" borderColor={!mobile ? Blue : Blue_400} padding={mobile && "15px 20px"}>
                        {mobile
                            ? <FontAwesomeIcon icon={faSave} />
                            : <Fragment>SAVE DESIGN</Fragment>
                        }
                    </Button>
                }
            </Block>
            {mobile
                && <P color="white"
                    hoverColor="white"
                    textTransform="uppercase"
                    flex="auto">
                    {state.step} {`(${(state.step === "Review") ? state.stepamount + 1 : state.stepnumber + 1} of ${state.stepamount + 1})`}
                </P>
            }
            {(state.step === "Review")
                ? <Flex borderLeft="1px solid lightgray" width="auto">
                    {mobile && (
                        <Button
                            onClick={() => setPopup(!popup)}
                            background={Blue_900}
                            hoverBackground={Blue_900}
                            border="2px solid"
                            borderColor={Blue_900}
                            padding="15px 20px"
                        >
                                {popup 
                                    ? <FontAwesomeIcon icon={faTimes} /> 
                                    : <FontAwesomeIcon icon={faBars} />
                                }
                        </Button>
                    )}
                    <Button
                        disabled={!state.addToCartCheck}
                        onClick={() => Submit()}
                        background={mobile && "green"}
                        hoverBackground={mobile ? "green" : "#074492"} border={mobile ? "2px solid green" : "2px solid #095ac3"}
                        padding={mobile && "15px 20px"}
                    >
                            {mobile ? <FontAwesomeIcon icon={faShoppingCart} /> : "ADD TO CART"}
                    </Button>
                </Flex>
                : <Flex borderLeft={mobile && "1px solid lightgray"} width="auto">
                    {mobile && (
                        <Button
                            onClick={() => setPopup(!popup)}
                            background={Blue_900}
                            hoverBackground={Blue_900}
                            border={mobile ? "none" : "2px solid #031d40"}
                            padding="15px 20px"
                        >
                            {popup ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
                        </Button>
                    )}
                    {next && (
                        <Button 
                            id ="goToNextStep"
                            tabIndex="0"
                            disabled={!state.choices[state.substep]?.completed}
                            onClick={() => NavigateNext()}
                            hoverBackground={!mobile ? Blue : Blue_400}
                            border="2px solid" borderColor={!mobile ? Blue : Blue_400}
                            padding={mobile && "15px 20px"}
                            background={!mobile ? Blue : Blue_400}
                        >
                            {mobile
                                ? <FontAwesomeIcon icon={faChevronRight} />
                                : <Fragment>NEXT: {next.title?.toUpperCase()} <FontAwesomeIcon icon={faArrowRight} /></Fragment>
                            }
                        </Button>)
                    }
                </Flex>
            }
        </Flex>
    )
}